export default "__VITE_ASSET__B6Tm5$nL__"